// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from DrawerBar.module.scss  */
.DrawerBar-module-Root_2RF {
  position: fixed;
  z-index: 1001;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
  user-select: none;
  border-radius: 2em 2em 0 0;
  background-color: #fff;
  box-shadow: 0 0.25em 1.25em rgba(0, 0, 0, 0.1);
  will-change: transform;
  transition-timing-function: ease;
  transition-property: transform, width;
  /* https://stackoverflow.com/questions/48124372/pointermove-event-not-working-with-touch-why-not#answers-header */
  touch-action: none; }

.DrawerBar-module-overlayMode_3VY {
  max-height: calc(100% - 3em);
  padding: 0;
  border: 0; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Drawer/DrawerOverlay/Bar/DrawerBar.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,eAAe;EACf,aAAa;EACb,SAAS;EACT,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,0BAA0B;EAC1B,sBAAsB;EACtB,8CAA8C;EAC9C,sBAAsB;EACtB,gCAAgC;EAChC,qCAAqC;EACrC,iHAAiH;EACjH,kBAAkB,EAAE;;AAEtB;EACE,4BAA4B;EAC5B,UAAU;EACV,SAAS,EAAE","sourcesContent":["/*  imported from DrawerBar.module.scss  */\n.DrawerBar-module-Root_2RF {\n  position: fixed;\n  z-index: 1001;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  width: 100%;\n  user-select: none;\n  border-radius: 2em 2em 0 0;\n  background-color: #fff;\n  box-shadow: 0 0.25em 1.25em rgba(0, 0, 0, 0.1);\n  will-change: transform;\n  transition-timing-function: ease;\n  transition-property: transform, width;\n  /* https://stackoverflow.com/questions/48124372/pointermove-event-not-working-with-touch-why-not#answers-header */\n  touch-action: none; }\n\n.DrawerBar-module-overlayMode_3VY {\n  max-height: calc(100% - 3em);\n  padding: 0;\n  border: 0; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
